// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../../core/resource.mjs";
import * as AgentsAPI from "./agents.mjs";
import { Agents } from "./agents.mjs";
import { path } from "../../internal/utils/path.mjs";
export class Templates extends APIResource {
    constructor() {
        super(...arguments);
        this.agents = new AgentsAPI.Agents(this._client);
    }
    /**
     * Creates a new template from an existing agent or agent file
     */
    create(body, options) {
        return this._client.post('/v1/templates', { body, ...options });
    }
    /**
     * Updates the current working version of a template from an agent file
     */
    update(templateName, body, options) {
        return this._client.patch(path `/v1/templates/${templateName}`, { body, ...options });
    }
    /**
     * Deletes all versions of a template with the specified name
     */
    delete(templateName, body, options) {
        return this._client.delete(path `/v1/templates/${templateName}`, { body, ...options });
    }
    /**
     * Rollback the current working version of a template to a previous saved version.
     * If the current version has unsaved changes, they will be automatically saved as
     * a new version before rollback.
     */
    rollback(templateName, body, options) {
        return this._client.post(path `/v1/templates/${templateName}/rollback`, { body, ...options });
    }
    /**
     * Saves the current version of the template as a new version
     */
    save(templateName, body = {}, options) {
        return this._client.post(path `/v1/templates/${templateName}/save`, { body, ...options });
    }
}
Templates.Agents = Agents;
//# sourceMappingURL=templates.mjs.map